const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.mov'];
const BACKGROUND_AUDIO_UNLOCK_EVENT = 'background-audio-unlock';

let backgroundAudioUnlocked = false;

export function isVideoAsset(url: string | undefined): boolean {
  if (!url) return false;
  const path = url.split('?')[0].toLowerCase();
  return VIDEO_EXTENSIONS.some((ext) => path.endsWith(ext));
}

/** Absent or `true` loops. `false` plays once and holds the last frame. */
export function isBackgroundVideoLoop(backgroundLoop?: boolean): boolean {
  return backgroundLoop !== false;
}

/** Keep the last displayed frame after a one-shot background video ends. */
export function holdBackgroundVideoLastFrame(video: HTMLVideoElement): void {
  video.pause();
  if (!Number.isFinite(video.duration) || video.duration <= 0) return;
  const lastFrameTime = Math.max(0, video.duration - 0.05);
  if (Math.abs(video.currentTime - lastFrameTime) > 0.01) {
    video.currentTime = lastFrameTime;
  }
}

export function isBackgroundAudioUnlocked(): boolean {
  return backgroundAudioUnlocked;
}

/** Call after a user gesture so background music can start (videos stay muted). */
export function unlockBackgroundAudio(): void {
  if (backgroundAudioUnlocked) return;
  backgroundAudioUnlocked = true;
  window.dispatchEvent(new Event(BACKGROUND_AUDIO_UNLOCK_EVENT));
}

export function onBackgroundAudioUnlock(callback: () => void): () => void {
  if (backgroundAudioUnlocked) {
    callback();
    return () => {};
  }
  window.addEventListener(BACKGROUND_AUDIO_UNLOCK_EVENT, callback);
  return () => window.removeEventListener(BACKGROUND_AUDIO_UNLOCK_EVENT, callback);
}

export function applyBackgroundVideoAudio(video: HTMLVideoElement): void {
  video.muted = true;
  void video.play().catch(() => {});
}

export function preloadVideo(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'auto';
    video.muted = true;
    video.onloadeddata = () => resolve();
    video.onerror = () => reject(new Error(`Failed to load video: ${url}`));
    video.src = url;
  });
}
